export function mapBrowserLanguageLocale(
  navigatorLanguage: string,
  supportedLanguages: string[],
  defaultValue: string
): string {
  if (navigatorLanguage === '') {
    return defaultValue
  }

  const supportedLanguage = supportedLanguages.find((supportedLanguage) =>
    supportedLanguage.includes(navigatorLanguage)
  )
  return supportedLanguages.length > 0 && supportedLanguage !== undefined
    ? supportedLanguage
    : defaultValue
}

export function getLanguageCode(
  navigatorLanguage: string,
  supportedLanguages: string[],
  defaultValue: string
): string {
  if (navigatorLanguage === '') {
    return defaultValue
  }

  if (
    supportedLanguages.find((supportedLanguage) =>
      supportedLanguage.includes(navigatorLanguage)
    ) === undefined
  ) {
    return defaultValue
  }

  return navigatorLanguage
}
